import { cva, type VariantProps } from 'class-variance-authority'

export const inputVariants = cva(
  'font-sans text-sm text-ink bg-surface placeholder:text-ink-4 focus:outline-none w-full',
  {
    variants: {
      variant: {
        default: 'border border-line rounded-md px-3 py-2 focus:border-ink-2 transition-colors',
        inset:
          'border-0 border-b border-line bg-transparent px-0 py-2 rounded-none focus:border-ink transition-colors',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type InputVariantProps = VariantProps<typeof inputVariants>
